import { render, staticRenderFns } from "./ModalDeletePlan.vue?vue&type=template&id=6cb68ead&"
import script from "./ModalDeletePlan.vue?vue&type=script&lang=js&"
export * from "./ModalDeletePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports